interface LogMessage {
    name?: string;
    message: string;
    stack?: string;
    siteKey?: string;
    invoiceId: string;
}

class Logging {
    static globalSiteKey: string = '';
    static invoiceId: string = '';

    static SetGlobalSiteKey(siteKey: string) {
        this.globalSiteKey = siteKey;
    }

    static SetInvoiceId(invoiceId?: string) {
        if (invoiceId == null) return;

        this.invoiceId = invoiceId;
    }

    static LogError(error: Error) {
        if (!error) return null;

        let logMessage: LogMessage = {
            name: error.name,
            message: error.message,
            stack: error?.stack ?? '',
            siteKey: this.globalSiteKey,
            invoiceId: this.invoiceId,
        };
        let logMessageJson = JSON.stringify(logMessage);

        console.error(logMessageJson);

        try {
            return fetch(`log/error`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: logMessageJson,
            });
        } catch {
            // No exception
        }
    }

    static LogWarning(message: string) {
        if (!message) return null;

        let logMessage: LogMessage = { message: message, siteKey: this.globalSiteKey, invoiceId: this.invoiceId };
        let logMessageJson = JSON.stringify(logMessage);

        try {
            return fetch(`log/warning`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: logMessageJson,
            });
        } catch {
            // No exception
        }
    }

    static LogInfo(message: string) {
        if (!message) return null;

        let logMessage: LogMessage = { message: message, siteKey: this.globalSiteKey, invoiceId: this.invoiceId };
        let logMessageJson = JSON.stringify(logMessage);

        try {
            return fetch(`log/info`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: logMessageJson,
            });
        } catch {
            // No exception
        }
    }
}

export default Logging;
